document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('gb-countdown');
  if (!el) return;

  const endTime = new Date(el.dataset.end).getTime();

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const diff = endTime - Date.now();
    if (diff <= 0) {
      el.textContent = '00 : 00 : 00';
      return;
    }
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    el.textContent = pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
    setTimeout(tick, 1000);
  }

  tick();
});
